import { GridRows } from '@visx/grid';
import AnimatedGridLines from "./AnimatedGridLines.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedGridRows(_ref) {
  let {
    scale,
    width,
    numTicks,
    tickValues,
    offset,
    className,
    animationTrajectory,
    top,
    left,
    ...lineProps
  } = _ref;
  return /*#__PURE__*/_jsx(GridRows, {
    scale: scale,
    width: width,
    numTicks: numTicks,
    tickValues: tickValues,
    className: className,
    top: top,
    left: left,
    offset: offset,
    children: _ref2 => {
      let {
        lines
      } = _ref2;
      return /*#__PURE__*/_jsx(AnimatedGridLines, {
        scale: scale,
        lines: lines,
        animationTrajectory: animationTrajectory,
        animateXOrY: "y",
        lineKey: line => `row-${line?.from?.y ?? ''}-${line.index}`,
        ...lineProps
      });
    }
  });
}